"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M17 6c-.55 0-1 .45-1 1v7.59L3.71 2.29a1.003 1.003 0 00-1.42 1.42L14.59 16H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"];
//# sourceMappingURL=arrow-bottom-right.js.map